
import Button from '@/ui-kit/components/button';
import { ButtonFillType, ButtonProperty, ButtonPropsEventType } from '@/ui-kit/components/button/enums';
import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import { FormEventType } from '@/ui-kit/components/form/enums';
import { ButtonsProperty } from './enums';

export default {
  name: 'FormButtons',
  components: {
    Button,
  },
  props: {
    [ButtonsProperty.IsDisabled]: {
      type: Boolean,
      default: false,
    },
    [ButtonsProperty.IsLoading]: {
      type: Boolean,
      default: false,
    },
    [ButtonsProperty.SubmitButtonTitle]: {
      type: String,
      default: 'See Data',
    },
    [ButtonsProperty.SubmitButtonFillType]: {
      type: String,
      default: ButtonFillType.Outlined,
    },
    [ButtonsProperty.ResetButtonTitle]: {
      type: String,
      default: 'Reset Filters',
    },
    [ButtonsProperty.ShowResetButton]: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ButtonFillType,
      ButtonProperty,
      ButtonsProperty,
      ButtonPropsEventType,
      StyleColorSchemeType,
    };
  },
  methods: {
    handleSubmitClick() {
      this.$emit(FormEventType.Submit);
    },
    handleResetClick() {
      this.$emit('reset');
    },
  },
};
